
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Grid } from 'swiper/modules';
import {
 SwiperContainer,
 PartnerSlide
} from "../InfoSection/InfoSection.elements";
import { sponsors } from "./data";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


export default function Partners() {
 console.log(sponsors);

 return (
  <SwiperContainer>

   <Swiper
    modules={[Grid, Autoplay]}
    autoplay={{ delay: 1800, disableOnInteraction: false }}
    loop
    spaceBetween={24}
    slidesPerView={1}
    grid={{
     rows: 1,
    }}
    breakpoints={{
     480: {
      slidesPerView: 2,
      grid: { rows: 1 }
     },
     768: {
      slidesPerView: 3,
      grid: { rows: 1 }
     },
     1024: {
      slidesPerView: 4,
      grid: { rows: 1 }
     }
    }}
    style={{ width: '100%' }}
   >
    {sponsors.map((s, idx) => (
     <SwiperSlide key={idx}>
      <a href={s.url} target="_blank" rel="noopener noreferrer">
       <PartnerSlide invert={s.invert}>
        <img
         src={s.img}
         alt={s.name}
        />
       </PartnerSlide>
      </a>
     </SwiperSlide>
    ))}
   </Swiper>

  </SwiperContainer>
 );

}